import React, { useEffect, useContext } from 'react';
import api from '../api';
import { Context } from '../contexts/StateContext';
import { format } from 'date-fns';


//---------------------------
export function Api_Clientes() {
    const { state, dispatch } = useContext(Context);
    const { cliente, endereco, foneCelular, logado } = state.cliente;
    const { veiculo } = state.veiculo;
    const { listaPesquisa, parametroInit, playLista } = state.parametros;
    const id_Cliente = cliente.id_Cliente;

    // ----------Add so CPF------------------
    async function AddCPF({ nome, cpf, celular }) {
        if (cliente.nome?.length >= 3 || nome?.length >=3) {
            try {
                const res = await api.post('/cliente/add', {
                    userCadastro: logado.idLogado? logado.idLogado : null,
                    nome: nome || cliente.nome,
                    cpfCnpj: cpf || cliente.cpfCnpj,
                    foneCelular: {
                        numeroCel: celular || cliente.celular,
                    }
                })
                if (res.data) {
                    dispatch({
                        type: 'set_cliente',
                        payload: {
                            ...cliente,
                            id_Cliente: res.data._id,
                            cpfCnpj: res.data.cpfCnpj,
                            nome: res.data.nome,
                            celular: res.data.foneCelular.numeroCel,
                        }
                    });

                    dispatch({
                        type: 'set_fone',
                        payload: {
                            ...foneCelular,
                            numeroCel: res.data.foneCelular.numeroCel,
                        }
                    });


                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, botaoCPF: false }
                    });
                

                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { 
                            ...listaPesquisa, 
                            listaCliente: [res.data],
                            novoItem: '',
                        }
                    });

                    alert('CPF Salvo!');

                    return res.data
                };
            } catch (error) {
                    alert("Ocorreu um erro: AddCPF");
                    console.error(error);
            }
        } else {
            alert("Prencha o Nome Completo!")
        }
    };

    // ----------Add Condutor------------------
    // async function AddCondutor({ nome, cpf, celular }) {
    //     if (cliente.nome.length >= 3 || nome.length >=3) {
    //         try {
    //             const res = await api.post('/cliente/add', {
    //                 userCadastro: logado.idLogado? logado.idLogado : null,
    //                 nome: nome,
    //                 cpfCnpj: cpf ,
    //                 foneCelular: {
    //                     numeroCel: celular,
    //                 }
    //             });

    //             if (res.data) {
    //                 dispatch({
    //                     type: 'set_ListaPesquisa',
    //                     payload: { 
    //                         ...listaPesquisa, 
    //                         listaCondutor: [res.data]
    //                     }
    //                 });

    //                 alert('Condutor Salvo!');
    //             };

    //             return res.data
                
    //         } catch (error) {
    //             alert("Ocorreu um erro: AddCondutor");
    //             console.error(error);
    //         }
    //     } else {
    //         alert("Prencha Completo!")
    //     }
    // };


    // --------------------------------------
    async function buscarPorId() {
        if (cliente.clientePorId) {
            await api.get(`cliente/${id_Cliente}`)
                .then(res => {
                    const buscar = res.data;
                    dispatch({
                        type: 'set_cliente',
                        payload: { ...cliente, listaCliente: buscar }
                    });
                })
        };
    };

    //-------------------------------
    useEffect(() => {
        buscarPorId()
    }, [cliente.clientePorId])

    //-------------------------------
    async function BuscaTodosClientes() {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, detalhesLista: false, loading: true }
        });

        await api.get('/cliente/todos')
            .then(res => {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaCliente: res.data }
                });
                dispatch({
                    type: 'set_playLista',
                    payload: { ...playLista, playListaClie: true }
                });
            })
    };

    //-------------------------------
    async function pesqidcliente() {
        if (cliente.id_Cliente) {
            await api.get(`cliente/${cliente.id_Cliente}`)
                .then(res => {
                    const cli = res.data;

                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaCliente: res.data }
                    });

                    cli.map(e => {
                        dispatch({
                            type: 'set_cliente',
                            payload: {
                                ...cliente,
                                id_Franquia: e?.id_Franquia?._id,
                                id_Colaborador: e.id_Colaborador ? e.id_Colaborador._id : "",
                                status: e.status,
                                nome: e.nome,
                                cpfCnpj: e.cpfCnpj,
                                email: e.email,
                            }
                        });
                        dispatch({
                            type: 'set_endereco',
                            payload: {
                                ...endereco,
                                cep: e?.endereco?.cep,
                                estado: e?.endereco?.estado,
                                cidade: e?.endereco?.cidade,
                                rua: e?.endereco?.rua,
                                numeroCasa: e?.endereco?.numeroCasa,
                                bairro: e?.endereco?.bairro || "",
                            }
                        });
                        dispatch({
                            type: 'set_fone',
                            payload: {
                                ...foneCelular,
                                codigoArea: e?.foneCelular.codigoArea,
                                numeroCel: e?.foneCelular?.numeroCel || "",
                            }
                        });
                    })
                })
        }
    };

    // ---------------------------------------
    async function pesqClienteNome(nome) {
        console.log(nome)
        if (nome) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: true }
            });

            await api.get(`cliente/nome/${nome}`)
                .then(res => {
                    const data = res.data;

                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, loading: false }
                    });

                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaCliente: data.length > 0 ? data : [] }
                    });
                })
        }
    };

    // ---------------------------------------
    async function BuscaTodosUsuarios() {
        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, detalhesLista: false }
        });

        await api.get('/usuario/todos')
            .then(res => {
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaUsuario: res.data }
                });
                dispatch({
                    type: 'set_playLista',
                    payload: { ...playLista, playListaUsuario: true }
                });
            })
    };

    // --------------------------------
    async function AtualizarCliente(t) {
        await api.put(`cliente/atualizar/${t._id}`, {
            status: 'A'
        })
            .then(res => {
                pesqidcliente();
            })
    };

    // -----------------------------------
    async function AtualizarIdCliente({arquivosConvertidos}) {
        if (cliente.id_Cliente) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: true}
            });

            const dadosArray = {
                placa: veiculo.placa,
                tipoFile: "selfie",
                data_modificado: Date.now(),
            };

            // Remover campos nulos
            Object.keys(dadosArray).forEach(key => {
                if (dadosArray[key] === null || dadosArray[key] === undefined || dadosArray[key] === "") {
                    delete dadosArray[key];
                }
            });

            const formData = new FormData();
            formData.append("cliente", JSON.stringify(dadosArray));

            let fileNew = arquivosConvertidos || listaPesquisa.listaArquivos;
            for (let i = 0; i < fileNew.length; i++) {
                formData.append(`file[${i}]`, fileNew[i]);
            };

            await api.put(`/cliente/atualizarCliente/${cliente.id_Cliente}`,
                formData
            ).then(res => {
                pesqidcliente();
                alert('Cliente Atualizado!');

            }).catch((error) => {
                alert("Ocorreu um erro");
                
            }).finally(()=>{
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loadBola: false}
                });
            });
        } else { alert("Nenhum cliente selecionado para atualizar!")}
    };

    // ------------------------------------------------
    return { BuscaTodosClientes, pesqidcliente, pesqClienteNome, AddCPF, BuscaTodosUsuarios, AtualizarCliente, AtualizarIdCliente }
};





